export enum PageType {
    Dashboard = 'dashboard'
}